<template>
  <v-app>
    <v-main >
            <Toaster  position="top-right" :expand="true" :visibleToasts="9" richColors closeButton :enableHtml='true' />
      <!-- <CustomSidebar />
      <TopBar />
      <router-view/> -->
      <Teleport to="body">
        <CustomSidebar v-if='isAuth' />
      </Teleport>
      <div class="container-fluid main_container" >
        <div class="row">
          <div :class="isAuth ? 'col-12 mainContentWithSidebar': 'col-12' " id="mainContent">
            <TopBar v-if='isAuth'/>
            <router-view :key="$route.fullPath" />
            <div id="footer"  v-if='isAuth'>
                  <div>
                    <img :src="require('@/assets/logo_innopearl.png')"  class="sidebar_logo_extra_small" alt="">
                    <div class="linksfootertermspolicy">
                        <a href="/datapolicy">Data policy</a>
                        <a href="/terms_and_conditions">Terms and conditions</a>
                        <span><a href="https://innopearl.ch" target="_blank">Innopearl © {{new Date().getFullYear() }}</a></span>
                    </div>
                  </div>
              
            </div>
          </div>
        </div>
      </div>


    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import CustomSidebar from '@/components/sidebar/CustomSidebar.vue';
import TopBar from '@/components/sidebar/TopBar.vue';
import { Toaster } from 'vue-sonner'
export default {
  name: 'App',
  components: {
    CustomSidebar,
    TopBar,
    Toaster
  },
  data: () => ({
    //
  }),
  mounted(){
      this.$store.commit('INITIALISESTORE')
  },
  computed: mapState(['isAuth']),
  watch: {
    '$route' (to) {
      document.title = to.name || 'Partner+ Club'
    },
  },
}
</script>

<style media="screen">

@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
@import url('https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap');
@import url('@/assets/css/candidate-card.css');
@import url('@/assets/css/modal.css');
@import url('@/assets/css/filter-panel.css');

:root{
  /* Charte graphique Innopearl Partner+ */
  --color-white: #F2F2F0;
  --color-gold: #D5A029;
  --color-dark-blue: #133967;
  --color-light-blue: #3981C3;
  --color-purple: #8679B7;
  --color-bg: #FFF;
  --gradient-blue: linear-gradient(90deg, #253571 0%, #3981C3 100%);

  /* Typographie */
  --font-title: 'Satoshi', sans-serif;
  --font-body: 'Open Sans', sans-serif;

  /* Tailles */
  --font-size-page-title: 28px;
  --font-size-section: 20px;
  --font-size-card: 16px;
  --font-size-body: 14px;
  --font-size-small: 13px;
  --font-size-xsmall: 12px;
}

/* Default text color — charte: Open Sans dark blue.
   Set on the root only, so descendants inherit by default but
   explicit color overrides (e.g. white on gradient headers) keep working. */
html,
body,
#app{
  font-family: var(--font-body);
  color: var(--color-dark-blue);
}

/* Action buttons — design system */
.primary-action-button,
.secondary-action-button,
.alternative-action-button {
  height: 38px;
  padding: 0 20px;
  border-radius: 10px;
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.2s ease, transform 0.1s ease, background 0.2s ease, color 0.2s ease;
  border: 2px solid transparent;
  box-sizing: border-box;
}
.primary-action-button:hover:not(:disabled),
.secondary-action-button:hover:not(:disabled) {
  opacity: 0.85;
}
.primary-action-button:active,
.secondary-action-button:active,
.alternative-action-button:active {
  transform: scale(0.97);
}
.primary-action-button:disabled,
.secondary-action-button:disabled,
.alternative-action-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.primary-action-button,
.primary-action-button:hover,
.primary-action-button:focus,
.primary-action-button:visited {
  background: var(--color-dark-blue) !important;
  color: #FFFFFF !important;
  border-color: var(--color-dark-blue) !important;
}
.secondary-action-button,
.secondary-action-button:hover,
.secondary-action-button:focus,
.secondary-action-button:visited {
  background: var(--color-gold) !important;
  color: var(--color-dark-blue) !important;
  border-color: var(--color-gold) !important;
}
.alternative-action-button,
.alternative-action-button:focus,
.alternative-action-button:visited {
  background: #FFFFFF !important;
  color: var(--color-dark-blue) !important;
  border-color: var(--color-dark-blue) !important;
}
.alternative-action-button:hover:not(:disabled) {
  background: var(--color-dark-blue) !important;
  color: #FFFFFF !important;
}

/* Modal close button (X) — white bg, dark blue icon */
.v-dialog .close,
.v-overlay__content .close{
  position: absolute !important;
  right: 12px !important;
  top: 12px !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  background: #FFFFFF !important;
  color: var(--color-dark-blue) !important;
  border: 1px solid rgba(19, 57, 103, 0.12) !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-family: var(--font-title) !important;
  font-weight: 700 !important;
  font-size: var(--font-size-card) !important;
  line-height: 1 !important;
  cursor: pointer !important;
  box-shadow: 0 2px 6px rgba(19, 57, 103, 0.08) !important;
  transition: background 0.2s ease, color 0.2s ease !important;
}
.v-dialog .close:hover,
.v-overlay__content .close:hover{
  background: var(--color-dark-blue) !important;
  color: #FFFFFF !important;
}
.v-dialog .close .v-icon,
.v-overlay__content .close .v-icon{
  color: inherit !important;
}

/* Back button — shared style (apply to <button> or <a>) */
.back-btn,
.back-btn:hover,
.back-btn:focus,
.back-btn:visited{
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  width: fit-content;
  max-width: max-content;
  gap: 12px;
  height: 36px;
  padding: 0 12px;
  background: transparent !important;
  border: none !important;
  border-radius: 10px;
  cursor: pointer;
  font-family: var(--font-title);
  font-weight: 700;
  font-size: var(--font-size-card);
  color: var(--color-dark-blue) !important;
  letter-spacing: -0.01em;
  text-decoration: none;
  transition: background-color 0.2s ease;
}
.back-btn:hover:not(:disabled){
  background: rgba(19, 57, 103, 0.05) !important;
}
.back-btn:disabled{
  opacity: 0.4;
  cursor: not-allowed;
}
.back-btn .back-btn__icon{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-gold);
}

.linksfootertermspolicy{
  display:flex;
  gap:10px;
  justify-content: center;
}
.linksfootertermspolicy a,
.linksfootertermspolicy a:hover{
  color: var(--color-dark-blue) !important;

}
*{
    font-family: var(--font-body) !important;
}

/* Titres : Satoshi pour h1–h6 + toute classe contenant "title" / "Title" */
h1, h2, h3, h4, h5, h6,
[class*="title"], [class*="Title"] {
    font-family: var(--font-title) !important;
}
  #content{
    /* margin-left: 15%; */
    background : var(--color-bg);
    min-height: calc(100vh);
    padding-bottom: 50px;

  }

  .main_container > .row > .col{
    padding: 0px !important;
    margin: 0px !important;
  }
  .main_container{
    padding-left: 0 !important;
    padding-right: 0 !important;
    max-width: none !important;
  }
  .main_container > .row{
    margin-left: 0 !important;
    margin-right: 0 !important;
    --bs-gutter-x: 0 !important;
  }
  .mainContentWithSidebar{
    margin-left: 240px !important;
    width: calc(100vw - 240px) !important;
    max-width: calc(100vw - 240px) !important;
    flex: 0 0 auto !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    overflow-x: hidden;
    box-sizing: border-box;
  }
  body,
  html,
  #app,
  .v-application,
  .v-application__wrap{
    background: #FFFFFF !important;
  }
  body{
    margin: 0 !important;
    background: #FFFFFF !important;
  }
  @media screen and (max-width: 1200px){
    .mainContentWithSidebar{
      margin-left: 60px !important;
      width: calc(100vw - 60px) !important;
      max-width: calc(100vw - 60px) !important;
    }
  }

  .prev_step_btn,
  .next_step_btn,
  .contact_step_btn{
      display:inline-block;
  }
  .mt20{
    margin-top: 20px;
  }

  @media screen and (max-width: 1200px){
    #mainContent{
      width:100%;
    }


  }

  @media screen and (max-width: 990px){
    .prev_step_btn,
    .next_step_btn,
    .contact_step_btn{
      font-size: var(--font-size-xsmall);

  }

  button.step{
    display: flex;
flex-direction: column;

  }
  }

.v-theme--myCustomLightTheme{
        --v-disabled-opacity: 1 !important;
    }

    @media (min-width: 1400px){
    .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
    max-width: 90% !important;
    }

  }

  a, a:hover{
    text-decoration: none !important;
  }

  #footer{
        background : var(--color-bg);
        padding:20px;
        text-align:center;
        font-size: var(--font-size-xsmall);
        color:#333;
  }
  #footer a{
    text-align:center;
  }

  .sidebar_logo_extra_small{
    width: 80px;
  height: 40px;
  }
  .v-btn--icon{
    border:none !important;
  }

  .footerAbs{
    position:absolute;
    bottom:20px;
    right:20px;
  }
  :focus-visible {
    outline: none !important;
  }

  .loaderInnopearl{
    display: flex;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
  }

  .loaderInnopearlInner{
    padding: 10px 50px;
  border: 1px solid rgba(57, 129, 195, 0.251);
  border-radius: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  color: var(--color-dark-blue);
  font-size:var(--font-size-section);
  font-weight: 600;
}
  .loaderInnopearlInner img{
    animation: rotating 3s linear infinite;
  }

  @keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.quicksearch input:-moz-placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.quicksearch input::placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.quicksearch input::-moz-placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.quicksearch input::-webkit-input-placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.quicksearch input:-ms-input-placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.quicksearch input::-ms-input-placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.v-dialog.nopaddd > .v-overlay__content > .v-card > .v-card-text{
  padding-top: 20px !important;
    padding-bottom: 20px !important;
    padding-left: 0 !important;
    padding-right: 0px !important;
}

.alert-info{
  background: #E9F1F8 !important;
  border: 1px solid rgba(55, 131, 197, .15) !important;
  color: var(--color-dark-blue) !important;
  font-weight: 500 !important;
  display: flex !important;
  gap: 20px !important;
  align-items: center;

}
.alert-info::before{
  content:url('notif.svg');
}

.alert-warning{
  background: #FFF4DE !important;
  border: 1px solid rgba(255, 170, 42, .15) !important;
  color: var(--color-dark-blue) !important;
  font-weight: 500 !important;
  display: flex !important;
  gap: 20px !important;
  align-items: center;

}
.alert-warning::before{
  content:url('notifWarning.svg');
}


.alert-success{
  background: #E7FFEF !important;
  border: 1px solid rgba(74, 222, 128, .15) !important;
  color: var(--color-dark-blue) !important;
  font-weight: 500 !important;
  display: flex !important;
  gap: 20px !important;
  align-items: center;

}
.alert-success::before{
  content:url('notifSuccess.svg');
}

</style>
